import { render, staticRenderFns } from "./TemplateHeader.vue?vue&type=template&id=18a0f416"
import script from "./TemplateHeader.vue?vue&type=script&lang=js"
export * from "./TemplateHeader.vue?vue&type=script&lang=js"
import style0 from "./TemplateHeader.vue?vue&type=style&index=0&id=18a0f416&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports